<div class="offers-list">
  <div *ngFor="let offer of offers"
       class="offers-list__offer">
    <app-next-offer [offer]="offer"
                    [comparisonOffersAmount]="offersSectionStateService.comparisonOffersAmount"
                    [compareCheckboxChecked]="offersSectionStateService.isOfferInComparison(offer)"
                    [addOfferToComparisonAllowed]="offersSectionStateService.addOfferToComparisonAllowed"
                    (addToComparison)="offersSectionStateService.addOfferToComparison(offer)"
                    (removeFromComparison)="offersSectionStateService.removeOfferFromComparison(offer)"
                    (showComparison)="offersSectionStateService.showOffersComparison()"
                    (showDetails)="offersSectionStateService.showOfferDetails(offer)"
                    (select)="offersSectionStateService.selectOffer(offer)"
    >
    </app-next-offer>
  </div>
</div>
